import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../api";
import { useAuth } from "../hooks/useAuth";

export default function MessageRendered() {
  const { user } = useAuth();

  let { messageId } = useParams();

  const [messageContent, setMessageContent] = useState<{ __html: any }>({
    __html: "messageId",
  });
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (messageId) {
      getMessage(messageId);
    }
  }, [messageId]);

  async function getMessage(messageId: string) {
    try {
      setLoading(true);
      const { data } = await api.messaging.getMessage(messageId);

      if (data.result) {
        setMessageContent({
          __html: data.result.content,
        });
        setLoading(false);
      }
    } catch (e) {
      if (axios.isAxiosError(e)) {
        if (e.response?.data) {
          toast.error(e.response?.data.errorMessage);
        }
      } else {
        console.log(e);
        toast.error(
          "Something really went wrong, you might want to contact support!"
        );
      }
    }
  }

  return (
    <div className="flex grow flex-col items-center">
      {/* MessageRendered */}
      <div className="flex mt-10 w-full lg:w-3/4">
        <div
          className="flex items-center justify-center w-full"
          dangerouslySetInnerHTML={messageContent}
        />
      </div>
    </div>
  );
}
